module.exports = __webpack_public_path__ + "static/media/intro4.3487908e.png";